import React  from 'react'

// showNormal = Solicitamos regresar al estado normal
export default function LoadPhoto( /*{showNormal, setSelectedImage}*/) {


    // onClick={()=> showNormal(false)}

    // sol1824M  , 040083
    
    function preImage( val )
    {
        console.log( "preImage") ;

        //setSelectedImage( val ) ;
        //showNormal( false ) ;
    }

  return (
    <>
        <div>Subir Foto(s)</div>
        <input type='file' 
          onChange={(event=>preImage(event.target.files[0]))} accept='image/*'></input>
        <button style={{borderRadius :'10px'}}>Regresar</button>
    </>
    
  )
}
